export const SERVER_FILE_SYSTEM = {
  "/": {
    type: "folder", name: "ROOT",
    children: ["USB_DEVICE", "CONFERENCE", "SYSTEM", "LOGS", "TMP"],
  },

  "/USB_DEVICE": {
    type: "folder", name: "USB_DEVICE", isUsb: true,
    children: [
      "preuve_001.pdf",
      "preuve_002.pdf",
      "preuve_003.pdf",
      "preuve_004.pdf",
      "preuve_005.pdf",
      "preuve_006.pdf",
    ],
  },

  "/USB_DEVICE/preuve_001.pdf": { type: "file", name: "preuve_001.pdf", isProof: true, proofIndex: 1 },
  "/USB_DEVICE/preuve_002.pdf": { type: "file", name: "preuve_002.pdf", isProof: true, proofIndex: 2 },
  "/USB_DEVICE/preuve_003.pdf": { type: "file", name: "preuve_003.pdf", isProof: true, proofIndex: 3 },
  "/USB_DEVICE/preuve_004.pdf": { type: "file", name: "preuve_004.pdf", isProof: true, proofIndex: 4 },
  "/USB_DEVICE/preuve_005.pdf": { type: "file", name: "preuve_005.pdf", isProof: true, proofIndex: 5 },
  "/USB_DEVICE/preuve_006.pdf": { type: "file", name: "preuve_006.pdf", isProof: true, proofIndex: 6 },

  "/CONFERENCE": {
    type: "folder", name: "CONFERENCE", isDestination: true, children: [],
  },

  "/SYSTEM": {
    type: "folder", name: "SYSTEM",
    children: ["kernel.bin", "init.sh", "CONFIG"],
  },
  "/SYSTEM/kernel.bin": { type: "file", name: "kernel.bin", isLure: true },
  "/SYSTEM/init.sh": { type: "file", name: "init.sh", isLure: true },
  "/SYSTEM/CONFIG": {
    type: "folder", name: "CONFIG",
    children: ["network.cfg", "hosts"],
  },
  "/SYSTEM/CONFIG/network.cfg": { type: "file", name: "network.cfg", isLure: true },
  "/SYSTEM/CONFIG/hosts": { type: "file", name: "hosts", isLure: true },

  "/LOGS": {
    type: "folder", name: "LOGS",
    children: ["access.log", "error.log", "auth.log"],
  },
  "/LOGS/access.log": { type: "file", name: "access.log", isLure: true },
  "/LOGS/error.log": { type: "file", name: "error.log", isLure: true },
  "/LOGS/auth.log": { type: "file", name: "auth.log", isLure: true },

  "/TMP": {
    type: "folder", name: "TMP",
    children: ["sess_tmp1", "sess_tmp2", "cache.bin"],
  },
  "/TMP/sess_tmp1": { type: "file", name: "sess_tmp1", isLure: true },
  "/TMP/sess_tmp2": { type: "file", name: "sess_tmp2", isLure: true },
  "/TMP/cache.bin": { type: "file", name: "cache.bin", isLure: true },
};

export function getStage3ServerProofPaths(playerCount) {
  const normalizedCount = [4, 5, 6].includes(Number(playerCount)) ? Number(playerCount) : 6;

  const allProofs = [
    "/USB_DEVICE/preuve_001.pdf",
    "/USB_DEVICE/preuve_002.pdf",
    "/USB_DEVICE/preuve_003.pdf",
    "/USB_DEVICE/preuve_004.pdf",
    "/USB_DEVICE/preuve_005.pdf",
    "/USB_DEVICE/preuve_006.pdf",
  ];

  return allProofs.slice(0, normalizedCount);
}

export function getStage3ServerVoteThresholds(playerCount) {
  const normalizedCount = [4, 5, 6].includes(Number(playerCount)) ? Number(playerCount) : 6;

  return {
    nav: 2,
    enter: Math.min(3, normalizedCount),
    copy: normalizedCount,
    paste: normalizedCount,
  };
}